import React from 'react';
import ReactDOM from 'react-dom/client';

// Components
import App from './App';

// Styles
import './index.css';

const whiteLabel = process.env.REACT_APP_WHITE_LABEL;

const whiteLabelColors = {
  ASEGURAME: './components/styles/color-white-label/colors-asegurame.css',
  CATOLICA: './components/styles/color-white-label/colors-catolica.css',
};

if (whiteLabel) {
  import(`${whiteLabelColors[whiteLabel]}`);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
